<template lang="pug">
v-row(no-gutters)
  v-col.pa-10(cols="3" xl="2")
    .sticky.top-24.white
      .text-md.font-semibold.neutral200.px-4.py-2.round-md.mb-2 {{ $t('business_details') }}
      .text-md.font-semibold.neutral500--text.px-4.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/tax')") {{ $t('tax_settings') }}
      .text-md.font-semibold.neutral500--text.px-4.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/e-invoice')") e-Invoice settings

  v-col.neutral200(cols="9" xl="10")
    v-form(ref="form")
      v-container.pa-8(fluid style="width:85%")
        .d-flex.align-center.mb-6
          v-btn.mr-4(icon small)
            v-icon(color="primary" @click="back") mdi-arrow-left
          .text-2xl.font-semibold {{ $t('business_details') }}

        v-card.round-xl.pa-6.mb-4(outlined)
          .h8.mb-5 Clinic details
          v-row
            v-col
              .text-sm.font-semibold.neutral700--text.mb-2 {{ $t('clinic_name') }}
              v-text-field.round-xl.mb-4(v-model="companyName" outlined :placeholder="$t('clinic_name_placeholder')" hide-details="auto" dense height="48" :rules="rules.not_empty")
              
              .company-address
                .text-sm.font-semibold.neutral700--text.mb-3 {{ $t('address') }}
                .mb-2
                  .text-xs.font-medium.neutral500--text.mb-2 {{$t('address_1.label')}}
                  v-text-field.round-xl(v-model="address.address_1" :placeholder="$t('address_1.placeholder')" dense outlined height="48" :rules="rules.not_empty" hide-details="auto")
                .mb-2
                  .text-xs.font-medium.neutral500--text.mb-2 {{$t('address_2.label')}}
                  v-text-field.round-xl(v-model="address.address_2" :placeholder="$t('address_2.placeholder')" dense outlined height="48" :rules="rules.not_empty" hide-details="auto")
                .mb-2
                  .text-xs.font-medium.neutral500--text.mb-2 {{$t('postcode.label')}}
                  v-text-field.round-xl(v-model="address.postcode" :placeholder="$t('postcode.placeholder')" dense outlined height="48" :loading="isFetching" :rules="rules.not_empty" @keyup="fetchPostcodes(address.postcode)" hide-details="auto")
                .mb-2
                  .text-xs.font-medium.neutral500--text.mb-2 {{$t('city.label')}}
                  v-text-field.round-xl(v-model="address.city" :placeholder="$t('city.placeholder')" dense outlined height="48" :loading="isFetching" :rules="rules.not_empty" hide-details="auto")
                .mb-2
                  .text-xs.font-medium.neutral500--text.mb-2 {{$t('state.label')}}
                  v-text-field.round-xl(v-model="address.state" :placeholder="$t('state.placeholder')" dense outlined height="48" :loading="isFetching" :rules="rules.not_empty" hide-details="auto")
                .mb-2
                  .text-xs.font-medium.neutral500--text.mb-2 {{$t('country.label')}}
                  v-text-field.round-xl(v-model="address.country" :placeholder="$t('country.placeholder')" dense outlined height="48" :loading="isFetching" :rules="rules.not_empty" hide-details="auto")

            v-col
              .text-sm.font-semibold.neutral700--text Clinic phone number
              phone-input.mt-2(ref="phoneInput" v-model="phone")
              .text-sm.font-semibold.neutral700--text.mt-4 {{ $t('clinic_email') }}
              v-text-field.round-xl.mt-2(v-model="email" outlined :placeholder="$t('clinic_email_placeholder')" hide-details="auto" dense height=48 :rules="rules.not_empty")
              .text-sm.font-semibold.neutral700--text.mt-4 {{ $t('company_logo') }}
              .text-sm.neutral500--text {{ $t('company_logo_description') }}
              .text-sm.neutral500--text Preferred dimension: Aspect ratio of 16:9
              .d-flex.align-center.mt-3
                v-card(v-if="resizeImageFileUrl" flat)
                  div(align="center")
                    v-img(:src="resizeImageFileUrl" contain max-height="90" max-width="140")
                      template(v-slot:placeholder)
                        v-row.fill-height.ma-0(align="center" justify="center")
                          v-progress-circular(indeterminate color="grey")
                v-card.round-xl.border-dashed(v-else outlined width="140")
                  .neutral200.text-center.pa-8
                    v-icon(color="neutral500" size="32") $yzi-image-01

                .file-change-layout.ml-4
                  v-btn.button-sm(color="basic700" outlined depressed) {{ $t('update') }}
                  input.input-change-layout(type="file" @change="onFileChange" accept="image/*" style="width: 92px !important")

        v-card.round-xl.pa-6.mb-4(outlined)
          .h8.mb-5 Registration number
          v-row
            v-col
              div.text-sm.font-medium.neutral700--text.mb-2 Registration Type
              y-select.mb-4(v-model="registrationType" :items="registrationTypes" item-text="name" item-value="code" placeholder="Select registration type" :loading="isFetching" :rules="rules.not_empty_select" attach)
            v-col
              .text-sm.font-semibold.neutral700--text.mb-2 Registration number
              v-text-field.round-xl.mb-4(v-model="registrationNumber" outlined placeholder="Enter company registration number" hide-details="auto" dense height=48)
          v-row
            v-col
              .text-sm.font-semibold.neutral700--text.mb-2 GST registration number
              v-text-field.round-xl.mb-4(v-model="gstRegistrationNumber" outlined placeholder="Enter GST registration number" hide-details="auto" dense height=48)
            v-col
              .text-sm.font-semibold.neutral700--text.mb-2 SST registration number
              v-text-field.round-xl.mb-4(v-model="sstRegistrationNumber" outlined placeholder="Enter SST registration number" hide-details="auto" dense height=48)

        v-card.round-xl.pa-6.mb-4(outlined)
          .h8.mb-5 Account details
          v-row
            v-col
              .text-sm.font-semibold.neutral700--text.mb-2 Account number
              v-text-field.round-xl.mb-4(v-model="accountDetail.accountNumber" outlined placeholder="Enter account number" hide-details="auto" dense height=48 :rules="accountDetailInserted ? rules.not_empty : []" :disabled="accountDetail.isFetching" :loading="accountDetail.isFetching")
            v-col
              .text-sm.font-semibold.neutral700--text.mb-2 Account holder name 
              v-text-field.round-xl.mb-4(v-model="accountDetail.accountHolderName" outlined placeholder="Enter account holder name" hide-details="auto" dense height=48 :rules="accountDetailInserted ? rules.not_empty : []" :disabled="accountDetail.isFetching" :loading="accountDetail.isFetching")
            v-col
              .text-sm.font-semibold.neutral700--text.mb-2 Bank
              v-select.round-xl(v-model="accountDetail.bank" attach :menu-props="{ top: true }" outlined placeholder="Select bank" dense hide-details="auto" height=48 item-value="name" :items="banks" item-text="name" background-color="basic200" :rules="accountDetailInserted ? rules.not_empty_select : []" clearable :disabled="accountDetail.isFetching" :loading="accountDetail.isFetching")
                template(v-slot:selection="data")
                  v-row(align="center")
                    v-col.py-0.shrink
                      v-avatar(size="20")
                        v-img(:src="data.item.image")
                    v-col.py-0
                      p.mb-0 {{ data.item.name }}
                template(v-slot:item="data")
                  v-row(align="center")
                    v-col.py-2.shrink
                      v-avatar(size="20")
                        v-img(:src="data.item.image")
                    v-col.py-2
                      p.mb-0 {{ data.item.name }}

    v-footer.white(app inset padless)
      .d-flex.flex-column.grow
        v-divider
        .d-flex.justify-end.align-center.py-4.px-8
          y-button(label="Cancel" size="sm" color="primary" underline @click="back" :disabled="isLoading")
          y-button.ml-2(label="Save" size="sm" color="primary" @click="save" :loading="isLoading")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'

export default {
  name: 'BusinessDetailsSettings',
  components: { PhoneInput },
  data () {
    return {
      companyName: null,
      email: '',
      phone: null,
      registrationNumber: '',
      registrationType: '',
      gstRegistrationNumber: '',
      sstRegistrationNumber: '',
      resizeImageFileUrl: null,
      resizeImageFile: null,
      isLoading: false,
      isFetching: false,
      address: {},
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        not_empty_select: [v => !!v || 'This field is required']
      },
      accountDetail: {
        isFetching: false,
        isError: false,
        id: null,
        accountNumber: null,
        accountHolderName: null,
        bank: null,
      },
      banks: [
        { id: 1, name: 'Affin Bank', image: require('@/assets/images/fpx/ABB0233.png') },
        { id: 2, name: 'Agrobank', image: require('@/assets/images/fpx/AGRO01.png') },
        { id: 3, name: 'Alliance Bank Malaysia', image: require('@/assets/images/fpx/ABMB0212.png') },
        { id: 4, name: 'AmBank', image: require('@/assets/images/fpx/AMBB0209.png') },
        { id: 5, name: 'CIMB', image: require('@/assets/images/fpx/BCBB0235.png') },
        { id: 6, name: 'Bank Islam Malaysia', image: require('@/assets/images/fpx/BIMB0340.png') },
        { id: 7, name: 'Bank Rakyat', image: require('@/assets/images/fpx/BKRM0602.png') },
        { id: 8, name: 'Bank Muamalat Malaysia', image: require('@/assets/images/fpx/BMMB0341.png') },
        { id: 9, name: 'Bank Simpanan Nasional', image: require('@/assets/images/fpx/BSN0601.png') },
        { id: 10, name: 'Hong Leong Bank', image: require('@/assets/images/fpx/HLB0224.png') },
        { id: 11, name: 'HSBC', image: require('@/assets/images/fpx/HSBC0223.png') },
        { id: 12, name: 'Kuwait Finance House', image: require('@/assets/images/fpx/KFH0346.png') },
        { id: 13, name: 'Maybank', image: require('@/assets/images/fpx/MBB0228.png') },
        { id: 14, name: 'OCBC Bank', image: require('@/assets/images/fpx/OCBC0229.png') },
        { id: 15, name: 'Public Bank', image: require('@/assets/images/fpx/PBB0233.png') },
        { id: 16, name: 'RHB Bank', image: require('@/assets/images/fpx/RHB0218.png') },
        { id: 17, name: 'Standard Chartered', image: require('@/assets/images/fpx/SCB0216.png') },
        { id: 18, name: 'United Overseas Bank', image: require('@/assets/images/fpx/UOB0226.png') },
      ],
      registrationTypes: [
        {
          code: "brn",
          name: "Company Registration Number (BRN)",
        },
        {
          code: "nric",
          name: "NRIC",
        },
        {
          code: "passport",
          name: "Passport",
        },
        {
          code: "army",
          name: "No Tentera / Army",
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    accountDetailInserted () {
      return !!this.accountDetail.bank || !!this.accountDetail.accountNumber || !!this.accountDetail.accountHolderName
    }
  },
  mounted () {
    if (this.company) {
      this.fetchAccountDetails()
      this.companyName = this.company.name
      this.email = this.company.email
      this.phone = this.company.phone
      this.registrationType = this.company.registration_type || ''
      this.registrationNumber = this.company.registration_number || ''
      this.gstRegistrationNumber = this.company.gst_registration_number || ''
      this.sstRegistrationNumber = this.company.sst_registration_number || ''
      this.address = this.company.address || {}
      this.resizeImageFileUrl = this.company.logo?.file ?? ''
    }
  },
  methods: {
    ...mapActions(['showMessage', 'updateCompany']),
    async fetchCompany (data) {
      await this.$axios.get(`/companies/${data.id}`)
        .then(resp => {
          this.updateCompany(resp.data)
        })
        .catch(() => {})
    },
    fetchPostcodes (val) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this.isFetching = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.address.postcode}`)
        .then(response => {
          const addresses = response.data
          if (addresses.length > 0 && addresses[0].postcode) {
            this.$set(this.address, 'city', addresses[0].city)
            this.$set(this.address, 'state', addresses[0].state)
            this.$set(this.address, 'country', addresses[0].country)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'company_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    back () {
      this.$router.push('/admin/clinic/settings')
    },
    save () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const formData = new FormData()
      formData.append('name', this.companyName)
      formData.append('email', this.email)
      formData.append('phone', this.phone)
      formData.append('registration_type', this.registrationType)
      formData.append('registration_number', this.registrationNumber)
      formData.append('gst_registration_number', this.gstRegistrationNumber)
      formData.append('sst_registration_number', this.sstRegistrationNumber)
      formData.append('address.address_1', this.address.address_1)
      formData.append('address.address_2', this.address.address_2)
      formData.append('address.postcode', this.address.postcode)
      formData.append('address.city', this.address.city)
      formData.append('address.state', this.address.state)
      formData.append('address.country', this.address.country)
      if (this.resizeImageFile) {
        formData.append('logo', this.resizeImageFile)
      }
      this.$axios.patch(`/companies/${this.company.id}`, formData)
        .then(async resp => {
          await this.fetchCompany(resp.data)
          await this.saveAccountDetails()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async fetchAccountDetails () {
      try {
        this.accountDetail.isFetching = true
        const params = { company: this.company.id }
        const { data } = await this.$axios.get('/directpay_creds/', { params })
        if (data.count > 0) {
          this.accountDetail.id = data.results[0].id
          this.accountDetail.accountNumber = data.results[0].bank_account
          this.accountDetail.accountHolderName = data.results[0].account_name
          this.accountDetail.bank = data.results[0].bank_name
        }
      } catch (error) {
        this.accountDetail.isError = true
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.accountDetail.isFetching = false
      }
    },
    async saveAccountDetails () {
      if (!this.accountDetailInserted) {
        if (this.accountDetail.id) {
          await this.$axios.delete(`/directpay_creds/${this.accountDetail.id}/`)
        }
        this.showMessage(['success', this.$t('success_message.successfully_updated')])
        return
      }
      try {
        const payload = {
          company: this.company.id,
          bank_name: this.accountDetail.bank,
          bank_account: this.accountDetail.accountNumber,
          enabled: true,
          account_name: this.accountDetail.accountHolderName
        }
        if (this.accountDetail.id) {
          await this.$axios.patch(`/directpay_creds/${this.accountDetail.id}/`, payload)
        } else {
          await this.$axios.post('/directpay_creds/', payload)
        }
        this.showMessage(['success', this.$t('success_message.successfully_updated')])
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
    }
  }
}
</script>

<style scoped>
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>

<i18n>
{
  "en": {
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "id": {
    "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    }
  }
}
</i18n>